import { render } from "./CreatePersonaModal.vue?vue&type=template&id=1accf0e3"
import script from "./CreatePersonaModal.vue?vue&type=script&lang=js"
export * from "./CreatePersonaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/CreatePersonaModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1accf0e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1accf0e3', __exports__)) {
    api.reload('1accf0e3', __exports__)
  }
  
  module.hot.accept("./CreatePersonaModal.vue?vue&type=template&id=1accf0e3", () => {
    api.rerender('1accf0e3', render)
  })

}


export default __exports__